import React, { Component } from 'react';
import { Text, View, Image, ScrollView, Dimensions, TouchableOpacity } from 'react-native';
import { postSingle, Flex, Padding, Margin, Helpers, Typo, homeCover, FontFamily, articleItemHorizontal, articleLists } from '../../styles/appStyles';
import TouchableOpacityLink from '../touchable-opacity-link';
import CustomImage from '../custom-image';
import { helpers } from '../../utils/helpers';
import moment from 'moment';


export class ArticleItemUserStory extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount = () => {
    }

    render() {
        const { data, viewArticle, viewAuthor, viewCategory, userCredits, home } = this.props;

        let btnClick, authorBtnClick, author2BtnClick, btnCategoryClick;
        if (helpers.isWeb()) {
            btnClick = {
                to: {
                    pathname: "/" + data.category.slug + "/" + data.slug,
                    postData: data
                }
            }
            btnCategoryClick = {
                to: "/category/" + data.category.slug
            }
            authorBtnClick = {
                to: "/writers/" + data.author[0].slug
            }
            if(data.author[1]) {
                author2BtnClick = {
                    to: "/writers/" + data.author[1].slug
                }
            }
        } else {
            btnClick = {
                onPress: () => viewArticle(data.category.slug, data.slug, data)
            }
            btnCategoryClick = {
                onPress: () => viewCategory(data.category.slug)
            }
            authorBtnClick = {
                onPress: (event) => {
                    event.stopPropagation();
                    viewAuthor(data.author[0].slug)
                }
            }
            if(data.author[1]) {
                author2BtnClick = {
                    onPress: (event) => {
                        event.stopPropagation();
                        viewAuthor(data.author[1].slug)
                    }
                }
            }
        }
        return (
            <TouchableOpacityLink
                {...btnClick}>
                <View style={[Flex.fill]}>
                    <TouchableOpacityLink {...btnCategoryClick}>
                        <View>
                            <Text style={[articleLists.badge, { width: 150, marginBottom: 15, textAlign: 'left', fontFamily: FontFamily.regular, color: '#907cff' },  !helpers.isWeb() && {fontFamily: FontFamily.semiBold}]}>{data.category.name}</Text>
                        </View>
                    </TouchableOpacityLink>
                    <View style={[Flex.column, userCredits && { paddingTop: 0 }, !helpers.isDesktop() && Margin.mb_4]}>
                        <View>
                            <View style={[Margin.mb_0, !helpers.isDesktop() && Margin.mr_2]}>
                                <CustomImage
                                    source={data.featured_image.sizes['thumb']}
                                    require={false}
                                    style={{ width: 125, height: 71 }}
                                    webStyle={{ width:'100%' , height: helpers.isDesktop() ? 230 : 300, objectFit: 'cover' }}
                                    resizeMode={'cover'}
                                    altText={(data.featured_image.alt && data.featured_image.alt != '') ? data.featured_image.alt : (data.title ? data.title : (data.story?.title ? data.story.title : data.featured_image.title))}
                                />
                            </View>
                        </View>
                        <View style={[Padding.pr_2]}>
                            <Text style={[articleItemHorizontal.articleTitle, !helpers.isDesktop() && articleItemHorizontal.articleMTitle ,Margin.mt_1, helpers.isDesktop() && {fontFamily: FontFamily.abrilFatface}, {height:70},  !helpers.isWeb() && articleItemHorizontal.articleTitleApp, home && Margin.mb_1]} numberOfLines={2}>{data.title}</Text>
                            <View style={[{ flexDirection: 'row', flexWrap: 'wrap', marginTop: 0, marginBottom: helpers.isDesktop() ? 0 : 10 }, !home && {marginBottom: 20} , {alignItems: 'center'}]}>
                                <View style={[Flex.row]}>
                                    <TouchableOpacityLink
                                        {...authorBtnClick}>
                                        <Text style={[articleItemHorizontal.authorTitle, helpers.isDesktop() && articleItemHorizontal.authorTitleDesktop, !helpers.isWeb() && articleItemHorizontal.authorTitleApp, !helpers.isDesktop() && {fontSize: 14}]}>{data.author[0].name}</Text>
                                    </TouchableOpacityLink>
                                    {data.author[1] && <>
                                            <Text style={[articleItemHorizontal.authorTitle, helpers.isDesktop() && articleItemHorizontal.authorTitleDesktop, !helpers.isWeb() && articleItemHorizontal.authorTitleApp, articleItemHorizontal.date, !helpers.isDesktop() && {fontSize: 14},{ fontFamily: FontFamily.light}]}> and </Text>
                                            <TouchableOpacityLink
                                                {...author2BtnClick}>
                                                <Text style={[articleItemHorizontal.authorTitle, helpers.isDesktop() && articleItemHorizontal.authorTitleDesktop, !helpers.isWeb() && articleItemHorizontal.authorTitleApp, !helpers.isDesktop() && {fontSize: 14}]}>{data.author[1].name}</Text>
                                            </TouchableOpacityLink>
                                        </>
                                    }
                                </View>
                                <View style={[articleItemHorizontal.dot, helpers.isDesktop() && articleItemHorizontal.dotDesktop]}></View>
                                <Text style={[articleItemHorizontal.articleDate, helpers.isDesktop() && articleItemHorizontal.articleDateDesktop, !helpers.isWeb() && articleItemHorizontal.articleDateApp,{color: '#5a5a5a', marginTop: 4},!helpers.isDesktop() && {fontSize: 14}]}>{moment(data.published_date).format('DD MMMM YYYY')}</Text>
                            </View>
                            <View style={[articleItemHorizontal.lineBreak, Margin.mt_0, Margin.mb_1, helpers.isDesktop() && [Margin.mb_2, Margin.mt_1]]}></View>
                            <View style={[Margin.mb_2, {maxWidth: '100%', width: 'auto'}]}>
                                <Text style={[homeCover.content, helpers.isDesktop() && homeCover.contentDesktop, {maxWidth: '100%'}]} numberOfLines={3}>{data.excerpt}</Text>
                            </View>
                        </View>
                    </View>
                </View>
            </TouchableOpacityLink>
        );
    }
}

export default ArticleItemUserStory;